import axios from "axios";

export default class UserRepository {
    async getUser(login, password) {
        try {
            const response = await axios.post('https://spring-boot-integracao-backend-official-1.onrender.com/usuarios/auth', {
                login: login,
                senha: password
            });
            return response.data;
        } catch (error) {
            console.error("Erro ao buscar aluno:", error);
            throw error;
        }
    }

    async getUserInfos(usuarioId) {
        try {
            const response = await axios.get(`https://spring-boot-integracao-backend-official-1.onrender.com/usuarios/${usuarioId}/dashboard`)
            return response.data;
        } catch (error) {
            console.error("Erro ao buscar os dados do aluno", error);
            throw error;
        }
    }

}